import {registerLocale, setDefaultLocale} from  'react-datepicker'
import is from 'date-fns/locale/is'

// Set the default locale for react-datepicker:
registerLocale('is', is)
setDefaultLocale('is')

export default {
  saleor: {
    apiUrl: process.env.REACT_APP_SALEOR_API_URL || '/graphql/',
  },
  apollo: {},
  restApi: {
    url: process.env.REACT_APP_REST_API_URL || '/api/',
  },
}
